/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';
import { ClipboardPenLine } from 'lucide-react';
import { chamarApi } from '@/nucleo/auth/cliente-api';
import { Button } from '@/ui/base/button';
const NS = '/bff/v1/j09-s04-analista-instruir';
export function InstruirDefesaPage() {
  const [e, setE] = useState<any>();
  const [id, setId] = useState('');
  const [fund, setFund] = useState('');
  const [busy, setBusy] = useState(false);
  async function call(p: string, b?: any) {
    setBusy(true);
    try {
      const x = await chamarApi<any>(NS + p, { metodo: p === '/state' ? 'GET' : 'POST', corpo: b });
      setE(x.state);
    } finally {
      setBusy(false);
    }
  }
  useEffect(() => {
    void call('/state');
  }, []);
  useEffect(() => {
    if (e && !id) setId(e.defesas[0]?.id ?? '');
  }, [e, id]);
  if (!e) return <p role="status">Carregando autos…</p>;
  const d = e.defesas.find((x: any) => x.id === id),
    p = e.pareceres.find((x: any) => x.defesa_id === id),
    imp = e.impedimentos.find((x: any) => x.defesa_id === id);
  return (
    <main className="w-full min-w-0 space-y-4 overflow-x-hidden">
      <h1 className="text-3xl font-semibold">
        <ClipboardPenLine className="mr-2 inline" />
        {e.titulo}
      </h1>
      <p>{e.descricao}</p>
      {e.alertas.map((a: any) => (
        <p role="alert" key={a.codigo}>
          {a.mensagem} <code>{a.codigo}</code>
        </p>
      ))}
      <label>
        Defesa
        <select
          className="block w-full rounded-md border bg-background p-2"
          value={id}
          onChange={(x) => setId(x.target.value)}
        >
          {e.defesas.map((x: any) => (
            <option key={x.id} value={x.id}>
              {x.protocolo} · {x.fila}
            </option>
          ))}
        </select>
      </label>
      {d && (
        <article className="rounded-md border p-3">
          <strong>
            {d.notificacao_numero} · {d.ocorrencia_protocolo}
          </strong>
          <p>{d.inteiro_teor}</p>
          <p>{d.texto}</p>
          <code className="break-all">{d.texto_hash}</code>
        </article>
      )}
      {p ? (
        <article className="rounded-md border p-3">
          <h2 className="font-semibold">Parecer v{p.versao}</h2>
          <p>{p.fundamento}</p>
          <p>
            {p.recomendacao} · R$ {p.valor_recomendado}
          </p>
          <code className="break-all">{p.parecer_hash}</code>
        </article>
      ) : (
        <>
          <label htmlFor="parecer">Fundamento do parecer</label>
          <textarea
            id="parecer"
            className="min-h-32 w-full rounded-md border bg-background p-3"
            value={fund}
            onChange={(x) => setFund(x.target.value)}
          />
          <Button
            disabled={busy || fund.length < 30}
            onClick={() =>
              void call('/verbs/instruir_defesa', {
                defesaId: id,
                fundamento: fund,
                recomendacao: 'MANTER',
                valorRecomendado: Number(d?.valor_proposto ?? 0),
                chaveIdempotencia: crypto.randomUUID(),
              })
            }
          >
            Emitir parecer
          </Button>
          <Button
            variant="outline"
            disabled={busy || fund.length < 20}
            onClick={() =>
              void call('/verbs/declarar_impedimento', {
                defesaId: id,
                tipo: 'CONFLITO_INTERESSE',
                fundamento: fund,
                chaveIdempotencia: crypto.randomUUID(),
              })
            }
          >
            Declarar conflito
          </Button>
        </>
      )}
      {imp && (
        <p role="status">
          Aplicação suspensa por {imp.tipo}: {imp.fundamento}
        </p>
      )}
      {e.resultado && <p role="status">Operação persistida: {JSON.stringify(e.resultado)}</p>}
    </main>
  );
}
